import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule  } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { IonicModule, IonicRouteStrategy, IonRouterOutlet } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// import { PapaParseModule } from 'ngx-papaparse';
import { File } from '@ionic-native/file/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { AllInOneSDK } from '@ionic-native/all-in-one-sdk/ngx';
import { LoanStatusComponent } from './pages/loan-status/loan-status.component';
import { HTTP } from '@ionic-native/http/ngx';
// import { AllInOneSDK } from 'node_modules2/@ionic-native/all-in-one-sdk';
@NgModule({
  declarations: [AppComponent, LoanStatusComponent],
  entryComponents: [],
  imports: [
    BrowserModule, 
    IonicModule.forRoot(), 
    AppRoutingModule,
    HttpClientModule,
    // PapaParseModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    FileOpener,
    File,
    SocialSharing,
    AllInOneSDK,
    HTTP
  ],
  bootstrap: [AppComponent],
  exports: [LoanStatusComponent]
})
export class AppModule {}
